import * as SelectPrimitive from "@radix-ui/react-select";
import { Check } from "lucide-react";
import { Select, SelectContent, SelectTrigger, SelectValue } from "@/components/ui/select";
import { JENIS_OPTIONS, slugify } from "@/lib/constants";
import { cn } from "@/lib/utils";

const JenisItem = ({ option }) => {
  const Icon = option.icon;
  return (
    <SelectPrimitive.Item
      value={option.value}
      data-testid={`jenis-option-${slugify(option.value)}`}
      className="relative flex cursor-pointer select-none items-start gap-3 rounded-lg py-2.5 pl-2.5 pr-8 outline-none transition-colors data-[highlighted]:bg-emerald-50 data-[state=checked]:bg-emerald-50/70"
    >
      <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-slate-100 text-emerald-700">
        <Icon className="h-4 w-4" />
      </span>
      <span className="flex flex-col">
        <SelectPrimitive.ItemText>
          <span className="text-sm font-semibold text-slate-900">{option.value}</span>
        </SelectPrimitive.ItemText>
        {option.desc && <span className="text-xs text-slate-500">({option.desc})</span>}
      </span>
      <SelectPrimitive.ItemIndicator className="absolute right-2.5 top-3.5">
        <Check className="h-4 w-4 text-emerald-600" />
      </SelectPrimitive.ItemIndicator>
    </SelectPrimitive.Item>
  );
};

export const JenisSelect = ({ value, onChange, invalid }) => (
  <Select value={value} onValueChange={onChange}>
    <SelectTrigger
      id="jenis"
      data-testid="select-jenis-pengaduan"
      className={cn(
        "h-11 rounded-xl border-slate-200 bg-white px-3.5 text-sm transition-colors hover:border-emerald-300 focus:ring-2 focus:ring-emerald-500/30",
        invalid && "border-rose-400",
      )}
    >
      <SelectValue placeholder="Pilih jenis pengaduan" />
    </SelectTrigger>
    <SelectContent className="max-h-80 rounded-xl bg-white">
      {JENIS_OPTIONS.map((opt) => (
        <JenisItem key={opt.value} option={opt} />
      ))}
    </SelectContent>
  </Select>
);
